<template>
    <FormInputContainer class="FormPasswordInput" :inputId="`I${_uid}`" :label="label" :errors="errors" :required="required">
        <input
            :id="`I${_uid}`"
            type="password"
            :value="value"
            :name="name"
            v-on="{ [lazy ? 'change' : 'input']: handleInput }"
            :disabled="disabled"
        />
    </FormInputContainer>
</template>


<script>
import FormInputContainer from './FormInputContainer';

export default {
    name: 'FormPasswordInput',

    components: { FormInputContainer },

    props: {
        value: { type: String },
        name: { type: String },
        label: { type: String },
        disabled: { type: Boolean, default: false },
        lazy: { type: Boolean, default: false },
        errors: { type: Array },
        required: { type: Boolean, default: false },
    },

    methods: {
        handleInput(event) {
            this.$emit('input', event.target.value);
        },
    },
}
</script>


<style lang="scss" scoped>
@import 'globals.scss';

.FormPasswordInput {
    input {
        @extend %form-control;
    }
}
</style>
